import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setPreviewOnly } from '../../reducers/RenderRequestSlice';

export const PreviewCheckBox = () => {
  const dispatch = useDispatch();
  const { isPreviewOnly } = useSelector((state: RootState) => state.renderRequest);

  return (
    <label className="check-row">
      <input
        type="checkbox"
        checked={isPreviewOnly}
        onChange={e => dispatch(setPreviewOnly(e.target.checked))}
      />
      <span>
        <b>Preview Only</b>
        <span className="info-icon" title="Preview the rendering without downloading the file.">i</span>
      </span>
    </label>
  );
};
